import { render, staticRenderFns } from "./TopMaiorFaturamentoCard.vue?vue&type=template&id=5ccfce61"
import script from "./TopMaiorFaturamentoCard.vue?vue&type=script&lang=js"
export * from "./TopMaiorFaturamentoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports